import styled from '@emotion/styled'

export const StyleImage = styled.img<any>`
  width: ${(props: any) => (props.width ? `${props.width}px` : 'auto')};
  height: ${(props: any) => (props.height ? `${props.height}px` : 'auto')};
  object-fit: ${(props: any) => props.fit || 'inherit'};
  border-radius: ${(props: any) => props.radius || 0}px;

  ${(props: any) => props?.customStyle};
`

export const ImageGalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const ActiveImage = styled.img`
  width: 340px;
  height: 400px;
  border-radius: 12px;
  object-fit: contain;
  transition: all 0.3s ease;
`

export const ThumbnailContainer = styled.div`
  display: flex;
  gap: 10px;
`

export const Thumbnail = styled.img<{ active?: boolean }>`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
  border: ${({ active }) =>
    active ? '3px solid #007bff' : '2px solid transparent'};
  opacity: ${({ active }) => (active ? 1 : 0.6)};
  transition: all 0.3s ease;

  &:hover {
    opacity: 1;
  }
`
